import { render, staticRenderFns } from "./AdminUpdateCategory.vue?vue&type=template&id=2ea3271e&scoped=true&"
import script from "./AdminUpdateCategory.vue?vue&type=script&lang=js&"
export * from "./AdminUpdateCategory.vue?vue&type=script&lang=js&"
import style0 from "./AdminUpdateCategory.vue?vue&type=style&index=0&id=2ea3271e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea3271e",
  null
  
)

export default component.exports